import styled from 'styled-components'

const StylePrev = styled.div`
        
        width: 40px;
        height: 40px;
        position: absolute;
        top: calc(50% - 45px);
        border-bottom: 4px solid;
        border-left:4px solid;
        transform: rotate(45deg);
        left: 25px;
        z-index:9998;
        cursor: pointer;
        border-color: transparent;
        &:hover {
            border-color: #A8A8A8;
        }
        @media (max-width: ${props => props.theme.breakpoints.xs}){
            width: 20px;
            height: 20px;
            border-bottom: 2px solid;
            border-left:2px solid;
            border-color:#A8A8A8;
        };
        &:before {
            content: '';
        }
`

const CardLoadMore = styled.div`
        display:flex;
        height:320px; 
        align-items:center;
        flex-wrap:wrap;
        align-content:center;     
        justify-content:center; 
        @media (max-width: ${props => props.theme.breakpoints.xs}){
            height:150px; 
            align-content:flex-start;
        }
`

const ParagraphLoadMore = styled.p`
        font-size:16px;
        @media (max-width: 600px){
            font-size:13px
        }
`

const StyleNext = styled.div`
        width: 40px;
        height: 40px;
        border-color: #FFF;
        position: absolute;
        top: calc(50% - 45px);
        border-bottom: 4px solid;
        border-left:4px solid;
        transform: rotate(-135deg);
        right: 25px;
        z-index:9998;
        cursor: pointer;
        border-color: transparent;
        &:hover {
            border-color: #A8A8A8;
        }
        @media (max-width: ${props => props.theme.breakpoints.xs}){
            width: 20px;
            height: 20px;
            border-bottom: 2px solid;
            border-left:2px solid;
            border-color:#A8A8A8;
        }; 
        &:before {
            content: '';
        }
`
interface TypeColor {
    color?: string;
  }

const BtnLoadMore = styled.button<TypeColor>`
        display: inline-block;
        font-weight: 400;
        line-height: 1.5;
        text-align: center;
        text-decoration: none;
        vertical-align: middle;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        user-select: none;
        border: 1px solid transparent;
        padding: .55rem 3rem;
        font-size: 1rem;
        border-radius: 0.25rem;
        transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
        color: #fff;
        background-color: ${props => props.color};
        border-color: ${props => props.color};
`


export {StylePrev, StyleNext, BtnLoadMore, CardLoadMore, ParagraphLoadMore}